<template >
  <base-dialog-form ref="gestLocationDialog" :title="computedTitle" :text="nome" color="secondary" icon="mdi-earth">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'" @click="saveLocation" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deleteLocation" color="error">{{ $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <form>
      <v-row>
        <v-col md="6" cols="12" class="text-center">
          <v-row>
            <v-col md="10" cols="6">
              <v-text-field v-model="nome" :disabled="method === 'VIEW'" :label="$t('name')" :rules="required"
                hide-details="auto"></v-text-field>
            </v-col>
            <v-col md="2" cols="6">
              <v-switch :disabled="method === 'VIEW'" v-model="ifActive" :label="$t('active_f_s')"></v-switch>
            </v-col>
            <v-col md="8" cols="6">
              <v-text-field v-model="url" :disabled="method === 'VIEW'" :label="$t('url')" :rules="required"
                hide-details="auto"></v-text-field>
            </v-col>
            <v-col md="2" cols="3">
              <v-switch :disabled="method === 'VIEW'" v-model="ifImpianto" :label="$t('sport_facility')"></v-switch>
            </v-col>
            <v-col md="2" cols="3">
              <v-autocomplete v-model="codiPai" :label="$t('nation')" :rules="required" :items="isoCode"
                :disabled="method === 'VIEW'" item-text="Name" item-value="Code" hide-details="auto"></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="6" cols="12" class="text-center">
          <my-img-uploader ref="imageUploader" v-model="image" :readOnly="method === 'VIEW'" :width="600" :height="300"
            :placeholder="$t('click_drag_here')"></my-img-uploader>
        </v-col>
      </v-row>
      <v-divider />
      <v-col md="12" cols="12">
        <br />
        {{ $t("description") }}
        <br />
        <br />
        <tiptap-vuetify :extensions="extensions" v-model="descr"></tiptap-vuetify>
      </v-col>
      <v-col cols="12">
        <select-on-map @coordinates="updateCoordinates" :coordX="coordX" :coordY="coordY" style="height: 800px"
          showCoordinates="false" />
      </v-col>
    </form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
import selectOnMap from "@/widget/selectOnMap.vue";
import MyImageUploader from "@/components/base/MyImageUploader.vue";

export default {
  name: "edit-location",
  components: {
    TiptapVuetify,
    selectOnMap,
    "my-img-uploader": MyImageUploader,
  },
  data() {
    return {
      locId: null,
      method: null,
      nome: null,
      descr: null,
      url: null,
      coordX: null,
      coordY: null,
      codiPai: null,
      image: null,
      ifActive: false,
      ifImpianto: false,
      isoCode: [],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(method, locId) {
      this.method = method;
      this.locId = locId;
      this.$refs.gestLocationDialog.open();
      this.loadData();
    },
    loadData() {
      let _ = this;
      _.isoCode = window.systemData.isoCode;
      if (_.locId !== null) {
        let url = "/auth/eventi/getLocation/" + _.locId;
        // Eventi aperti
        _.chiamataAxios("GET", url).then((response) => {
          _.nome = response.data.nome;
          _.descr = response.data.descr;
          _.url = response.data.url;
          _.coordX = response.data.coordX;
          _.coordY = response.data.coordY;
          _.codiPai = response.data.codiPai;
          _.image = response.data.image;
          _.ifActive = response.data.ifActive === 1 ? true : false;
          _.ifImpianto = response.data.ifImpianto === 1 ? true : false;
        });
      } else {
        _.nome = null;
        _.descr = "";
        _.url = null;
        _.codiPai = null;
        _.coordX = null;
        _.coordY = null;
        _.image = null;
        _.ifActive = true;
        _.ifImpianto = false;
      }
    },
    updateCoordinates(coord) {
      this.coordX = coord.coordX;
      this.coordY = coord.coordY;
    },
    deleteLocation(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/eventi/deleteLocation/" + _.locId,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.$emit("isUpdated", "true");
              _.$refs.gestLocationDialog.close();
            }
          });
        }
      });
    },
    saveLocation: function () {
      let _ = this;
      let url = "/auth/eventi/saveLocation/" + _.locId;
      _.$refs.imageUploader.updateImage();
      let method = "POST";
      if (_.method == "ADD") {
        url = "/auth/eventi/createLocation";
        method = "PUT";
      }
      _.chiamataAxios(method, url, {
        dialogLoader: true,
        body: {
          nome: _.nome,
          descr: _.descr,
          url: _.url,
          coordX: _.coordX,
          coordY: _.coordY,
          codiPai: _.codiPai,
          image: _.image,
          ifActive: _.ifActive ? 1 : 0,
          ifImpianto: _.ifImpianto ? 1 : 0,
        },
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$emit("isUpdated", "true");
          _.$refs.gestLocationDialog.close();
        }
      });
    },
  },
  computed: {
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_location");
      else if (this.method === "VIEW") return this.$t("view_location");
      else if (this.method === "ADD") return this.$t("create_location");
      else return "";
    },
  },
};
</script>
